import { useEffect } from 'react';

declare global {
  interface Window {
    initChatWidget: (config: any, delay?: number) => void;
  }
}

export default function Msg91Chat() {
  useEffect(() => {
    if (document.getElementById('msg91-chat-widget-script')) return;

    const script = document.createElement('script');
    script.id = 'msg91-chat-widget-script';
    script.src = 'https://blacksea.msg91.com/chat-widget.js';
    script.async = true;
    script.onload = () => {
      if (window.initChatWidget) {
        window.initChatWidget({
          widgetToken: "db33d",
          hide_launcher: true,
          show_widget_form: true,
          show_close_button: true,
          launch_widget: false,
          show_send_button: true,
          theme: "system"
        });
      }
    };

    document.body.appendChild(script);
  }, []);

  return null;
}
